import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import '../assets/css/gallery.css';

// Select 20 representative photos from various activities
const itemData = [
  { img: 'Handcarts15/H1.jpg', title: 'Handcarts Distribution' },
  { img: 'Embroidery Work/Emb2.jpg', title: 'Embroidery Work' },
  { img: 'Sewing_Class_Bani/SwingB1.jpeg', title: 'Sewing Classes' },
  { img: 'Health/Medicalcamp-Bhuj1.jpeg', title: 'Medical Camp' },
  { img: 'Health/Suvarna20241.jpeg', title: 'Suvarna Prashan' },
  { img: 'Health/Ayurvedic-camp1.jpg', title: 'Ayurvedic Camp' },
  { img: 'Education/Rkshabandhan-sanskar1.jpg', title: 'Raksha Bandhan' },
  { img: 'Education/kutch-Achary-traning1.jpeg', title: 'Teacher Training' },
  { img: 'Education/computer-class-rapar1.jpeg', title: 'Computer Classes' },
  { img: 'Social/Mass-wedding-Bhirandiyara1.jpg', title: 'Mass Wedding' },
  { img: 'Social/Ganesh-Banni1.jpeg', title: 'Ganesh Pujan' },
  { img: 'Social/Womens-Conference1.jpg', title: 'Women Empowerment' },
  { img: 'Organic Farming/ORG1.jpg', title: 'Organic Farming' },
  { img: 'SwingMachines5/5Machines1.jpg', title: 'Sewing Machines' },
  { img: 'Health/Menstruation-awareness1.jpeg', title: 'Health Awareness' },
  { img: 'Education/Gandhidham-banni-training1.jpg', title: 'Training Program' },
  { img: 'Social/Temple-Bidada-Gokul1.jpeg', title: 'Temple Consecration' },
  { img: 'Education/computer-lab-inaugurated1.jpeg', title: 'Computer Lab' },
  { img: 'Social/Distri-Dates-Bsf1.jpg', title: 'Supporting Soldiers' },
  { img: 'Ahir-Community/Wedding1.jpg', title: 'Community Support' }
];

export default function Gallery() {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval;
    const scrollSpeed = 1; // pixels per frame
    const scrollDelay = 30; // milliseconds

    const autoScroll = () => {
      if (!isPaused && scrollContainer) {
        scrollContainer.scrollLeft += scrollSpeed;
        
        // Reset to start when reaching the end
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0;
        }
      }
    };

    scrollInterval = setInterval(autoScroll, scrollDelay);

    return () => clearInterval(scrollInterval);
  }, [isPaused]);

  // Duplicate items for infinite scroll effect
  const duplicatedItems = [...itemData, ...itemData, ...itemData];

  return (
    <div className="gallery-section">
      <div className="gallery-container">
        <div 
          className="gallery-scroll-wrapper"
          ref={scrollRef}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="gallery-track">
            {duplicatedItems.map((item, index) => (
              <div key={`${item.title}-${index}`} className="gallery-item">
                <img
                  src={item.img}
                  alt={item.title}
                  loading="lazy"
                />
                <div className="gallery-overlay">
                  <span className="gallery-item-title">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}